import { Dimmer, Loader } from "semantic-ui-react";
import ConfirmModal from "../../../components/confirmViewModal/ConfirmModal";
import { TwScope } from "../../../components/ui/TwScope";
import FacilityDetailsModal from "../facilityDetails/FacilityDetailsModal";
import FacilityEditModal from "../facilityEdit/FacilityEditModal";
import FacilityRegisterModal from "../facilityRegister/FacilityRegisterModal";
import { FacilityListHeader } from "./components/FacilityListHeader";
import { FacilityListPagination } from "./components/FacilityListPagination";
import { FacilityListToolbar } from "./components/FacilityListToolbar";
import { FacilityTable } from "./components/FacilityTable";
import { useFacilityListViewModel } from "./hooks/useFacilityListViewModel";

const FacilityListNew = () => {
  const {
    visibleModal,
    setVisibleModal,
    visibleEditModal,
    setVisibleEditModal,
    visibleDetailsModal,
    setVisibleDetailsModal,
    showDeleteFacilityModal,
    setShowDeleteFacilityModal,
    viewFacilityData,
    editFacilityData,
    setEditFacilityData,
    deleteFacilityData,
    setDeleteFacilityData,
    register,
    refetch,
    countriesData,
    editFacilityLoading,
    facilityRows,
    totalCount,
    totalPages,
    rangeStart,
    rangeEnd,
    pageNumber,
    isTableLoading,
    refetchWithFilters,
    handlePagination,
    getFacilityDetails,
    handleFacilityDelete,
    getFacilityForEditDetails,
    enableEditFacility,
    deleteFacilityDetails
  } = useFacilityListViewModel();

  if (editFacilityLoading) {
    return (
      <Dimmer active>
        <Loader content="Loading" />
      </Dimmer>
    );
  }

  return (
    <>
      <TwScope className="tw-min-h-full tw-bg-white tw-p-6">
        <FacilityListHeader onRegisterClick={() => setVisibleModal(true)} />
        <FacilityListToolbar register={register} refetchWithFilters={refetchWithFilters} />
        <FacilityTable
          rows={facilityRows}
          isLoading={isTableLoading}
          countriesData={countriesData}
          onView={getFacilityDetails}
          onEdit={getFacilityForEditDetails}
          onDelete={handleFacilityDelete}
        />
        <FacilityListPagination
          rangeStart={rangeStart}
          rangeEnd={rangeEnd}
          totalCount={totalCount}
          pageNumber={pageNumber}
          totalPages={totalPages}
          onPageChange={handlePagination}
        />
      </TwScope>
      <FacilityRegisterModal
        visibleModal={visibleModal}
        setVisibleModal={() => {
          setVisibleModal(false);
          refetch();
        }}
      />
      <FacilityEditModal
        visibleModal={visibleEditModal}
        setVisibleModal={() => {
          setVisibleEditModal(false);
          refetch();
        }}
        facilityData={editFacilityData}
        updateFacilityData={setEditFacilityData}
      />
      <FacilityDetailsModal
        visibleModal={visibleDetailsModal}
        setVisibleModal={() => setVisibleDetailsModal(false)}
        facilityData={viewFacilityData}
        countries={countriesData}
        setVisibleEdit={enableEditFacility}
      />
      <ConfirmModal
        viewModal={showDeleteFacilityModal}
        closeModal={() => setShowDeleteFacilityModal(false)}
        cancel={() => {
          setShowDeleteFacilityModal(false);
          setDeleteFacilityData({});
        }}
        approve={() => {
          deleteFacilityDetails(deleteFacilityData);
          setDeleteFacilityData({});
          setShowDeleteFacilityModal(false);
        }}
        title="Delete Facility Data"
        subTitle="Are you sure you want to delete the facility?"
      />
    </>
  );
};

export default FacilityListNew;
